<template>
    <div
        class="md:w-full md:max-w-[400px] absolute left-1 right-1 top-1/2 md:top-36 lg:top-24 md:h-[85vh] md:max-h-[95%] md:left-auto md:right-6 bottom-2 md:bottom-auto rounded-lg border border-slate-200 shadow-lg px-3 pt-6 bg-white z-1050"
        v-if="show"
        style="transform: translate3d(0, 0, 170px)"
    >
        <div class="relative h-full flex flex-col" style="isolation: isolate">
            <div
                class="absolute right-0 top-0 flex justify-center items-center gap-2"
            >
                <FavButton
                    buttonClass="bg-white rounded-full p-1.5"
                    :isFavorite="isFavoriteAirport ? isFavoriteAirport : false"
                    @toggleFavorite="handleToggleFavorite"
                />
                <button
                    @click="$emit('close')"
                    class="w-8 h-8 bg-white rounded-full justify-center items-center p-2 text-slate-500 text-xl flex transition-colors z-10 hover:text-slate-400 hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:border-2"
                >
                    <Icon icon="close" />
                    <span class="sr-only">Close</span>
                </button>
            </div>
            <AirportCard
                :airport="infoWindowContent"
                cardClass="flex flex-col "
                :hideFavoriteButton="true"
                size="large"
            />

            <div class="overflow-y-auto relative mt-1 px-1">
                <p
                    class="text-slate-600 text-sm font-medium font-['Inter'] leading-tight"
                >
                    {{ searchResultsCount }} lounges
                </p>
                <div
                    v-for="(lounges, terminal, tIndex) in searchResults"
                    :key="'terminal-' + tIndex"
                    :class="{ 'mt-8': lounges.length }"
                >
                    <div
                        v-if="lounges.length > 0"
                        class="self-stretch pb-4 flex-col justify-start items-start flex"
                    >
                        <div
                            class="text-slate-800 text-lg font-medium font-['Inter'] leading-7"
                        >
                            {{ terminal }}
                        </div>
                    </div>

                    <LoungeCard
                        v-for="(lounge, lIndex) in lounges"
                        @click="handleClick"
                        :lounge="lounge"
                        :index="lIndex"
                        :key="'lounge-' + lIndex"
                        cardClass="flex-col justify-start items-start gap-3 flex w-full min-w-64 relative mb-8"
                    />
                </div>
            </div>
        </div>
        <LoadingState :loading="loading" />
    </div>
</template>
<script setup>
import _ from 'lodash';
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoungesStore } from '@/store/lounges';
import AirportCard from '@/components/tools/lounges/partials/airport-card/airport-card.vue';
import FavButton from '@/components/ui/fav-button/fav-button.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import LoungeCard from '@/components/tools/lounges/partials/lounge-card/lounge-card.vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    infoWindowContent: Object,
    show: { type: Boolean, default: false },
});
const emit = defineEmits(['favoriteChanged']);
const loungesStore = useLoungesStore();
const { searchLounges, setActiveAirport, setShowMap, toggleFavorite } =
    loungesStore;
const { loading, searchResultsCount, searchResults } =
    storeToRefs(loungesStore);
const isFavoriteAirport = ref(props.infoWindowContent.favorite);

const handleClick = () => {
    setShowMap(false);
};

const handleToggleFavorite = async () => {
    if (!props.infoWindowContent?.id) {
        console.error('No valid airport to favorite:', props.infoWindowContent);
        return;
    }
    isFavoriteAirport.value = !isFavoriteAirport.value;

    const res = await toggleFavorite(props.infoWindowContent, 'airport');
    if (!res || res.status !== 200) {
        isFavoriteAirport.value = !isFavoriteAirport.value;
    }

    emit('favoriteChanged');
};
watch(
    () => props.infoWindowContent,
    (newVal) => {
        if (!_.isEmpty(newVal)) {
            isFavoriteAirport.value = newVal.favorite;
            setActiveAirport(newVal);
            searchLounges();
        }
    }
);
</script>
